// extracted by mini-css-extract-plugin
export default {"grid":"order-delivery-tab_grid__jADEj"};